export default __webpack_public_path__ + "static/media/applicant-warning-icon.2e1099c1.svg";